// extracted by mini-css-extract-plugin
export default {"label":"Al24P1Wn9q4hWLjH7n1X"};